export default "__VITE_ASSET__0d202cf9__"